<template>
  <section class="relative px-3 py-10 sm:px-4 sm:py-16">
    <slot />
  </section>
</template>

<script>
  export default {
    name: 'UiSection',
  }
</script>

<style lang="postcss" scoped>
  section::v-deep(a:not(.bg-gradient-to-br)) {
    color: #06c;
  }
  section::v-deep(a:not(.bg-gradient-to-br):hover) {
    color: #39f;
  }

  section.light {
    @apply bg-gradient-to-br from-gray-200 to-gray-400;
  }
  section.gray {
    @apply bg-gradient-to-br from-gray-400 to-gray-600;
  }
  section.dark {
    @apply bg-gradient-to-br from-gray-700 to-gray-900 text-gray-100;
  }

  section.dark::v-deep(a:not(.bg-gradient-to-br)) {
    @apply text-blue-400;
  }
  section.dark::v-deep(a:not(.bg-gradient-to-br):hover) {
    @apply text-blue-300;
  }
</style>
